import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import ActsManagement from '../components/records/ActsManagement';

export default function RecordsSettingsPage() {
  const { t } = useTranslation('records');

  return (
    <>
      <Helmet>
        <title>{t('settings.pageTitle')}</title>
        <meta name="description" content={t('settings.pageDescription')} />
      </Helmet>

      <div className="min-h-screen">
        {/* Header */}
        <div className="mb-6">
          <Link
            to="/settings"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors mb-4"
          >
            <ArrowLeftIcon className="h-4 w-4" />
            {t('settings.backToSettings')}
          </Link>
          <h1 className="text-2xl font-bold text-card-foreground">
            {t('settings.title')}
          </h1>
          <p className="text-muted-foreground mt-1">
            {t('settings.subtitle')}
          </p>
        </div>

        {/* Acts Management */}
        <ActsManagement />
      </div>
    </>
  );
}
